/**
 * @generated SignedSource<<1bc08a1da94029897c7ddbd2b535f77e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternShopifyTokenDialogQuery$variables = {
  brandId: string;
};
export type InternShopifyTokenDialogQuery$data = {
  readonly internShopifyTokenStatus: {
    readonly accessTokenExpiresAt: any | null;
    readonly accessTokenLast4: string | null;
    readonly adminChangeUrl: string | null;
    readonly error: string;
    readonly refreshTokenExpiresAt: any | null;
    readonly refreshedAt: any | null;
    readonly state: string;
  };
};
export type InternShopifyTokenDialogQuery = {
  response: InternShopifyTokenDialogQuery$data;
  variables: InternShopifyTokenDialogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "brandId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "brandId",
        "variableName": "brandId"
      }
    ],
    "concreteType": "InternShopifyTokenStatus",
    "kind": "LinkedField",
    "name": "internShopifyTokenStatus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenLast4",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshTokenExpiresAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "refreshedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "adminChangeUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InternShopifyTokenDialogQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InternShopifyTokenDialogQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8b2e75dac2a59942bd5beb1fd20355a5",
    "id": null,
    "metadata": {},
    "name": "InternShopifyTokenDialogQuery",
    "operationKind": "query",
    "text": "query InternShopifyTokenDialogQuery(\n  $brandId: ID!\n) {\n  internShopifyTokenStatus(brandId: $brandId) {\n    state\n    accessTokenLast4\n    accessTokenExpiresAt\n    refreshTokenExpiresAt\n    refreshedAt\n    error\n    adminChangeUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "f10990b29967aeaa3a48ebc2b9340842";

export default node;
